var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cont_main[data-v-eeba79ca]{background-image:url(" + escape(require("../assets/pictures/1.jpg")) + ");background-repeat:no-repeat;background-position:50%;background-size:cover;background-attachment:fixed}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eeba79ca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/recover-password.vue
// module id = 376
// module chunks = 0